import React, { useEffect, useRef, useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { TbExternalLink } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const VideoModal = ({ showModal, handleClose, title, body, video,newWindow,resumeUrl }) => {

    
  const modalStyle = {
    display: showModal ? 'block' : 'none',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  };

  const iframeRef = useRef(null);


  const modalRef = useRef(null);

//   useEffect(() => {
//     // Reset scroll position when modal is closed
//     return () => {
//       const iframe = modalRef?.current?.querySelector('iframe');
//       if (iframe) {
//         iframe?.contentWindow?.scrollTo(0, 0);
//       }
//     };
//   }, []);

  // console.log('there')

  return (
    <div className="modal" tabIndex="-1" role="dialog" style={modalStyle}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title common_header p-0">{title}</h5>

            <div className='d-flex gap-3'>
                {newWindow && <a href={resumeUrl} target='_blank' rel="noreferrer"><TbExternalLink size={24} color='#286a94'/>  </a>}
    
                <IoClose 
                    // className="close pointer"
                    size={23}
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={handleClose}
                    color='red'
                    style={{cursor:"pointer"}}
                />
            </div>
              
            
          </div>
          <div className="modal-body" 
          ref={iframeRef}
          >{body}</div>
          {/* <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={handleClose}>
                Close
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
